export default {
  name: 'Form',
  label: {
    formItemName: 'Item',
    submitBtnContent: 'Submit button',
    submitUrl: 'Submit path',
    itemType: 'Type',
    option: 'Option',
    link: 'Consent',
    linkTip: 'Need upload agreement',
    isRequired: 'Required',
    clickUpload: 'Upload',
    attachment: 'Attachment',
    url: 'URL',
    uploadTips: 'Upload files such as pdf/html/document/picture, the size should not be larger than {maxSize}MB!',
    openAfterSubmit: 'Redirect URL'
  },
  placeholder: {
    submitBtnContent: 'Please enter submit button content',
    submitUrl: 'Please enter the form submission path (default submission to Ajinga, Ajinga provides data export)',
    itemType: 'Please select type',
    option: 'Option 1\nOption 2\nOption 3\n...etc',
    link: 'Please input consent',
    selectDate: 'Please select date',
    location: 'Please select location',
    country: 'Country/Region',
    province: 'Province/State',
    city: 'City/Town',
    select: 'Please select'
  },
  message: {
    titleRequired: 'Form title is required.',
    buttonContentRequired: 'Submit button content is required.',
    optionRequired: 'This field is required.',
    linkRequired: 'At least provides one link.',
    isRequired: 'This field is required.',
    locationRequired: 'Please select location',
    policyLinkRequired: 'Please agree to the terms to continue'
  }
}
